<template>
  <div>
    <div class="row pl-3 pr-3">
      <div style="display: inline-block;width: 350px">
        <dg-select-field
            class="float-left"
            :field_span="22"
            :label_span="22"
            defaultValue=""
            :options="filterOptions"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="filterOptionsUpdated"
            field_mark=""
            label="Filter Property"
            name="destination"
            placeholder="Filter"
            rules="optional"></dg-select-field>
      </div>
      <!--<div style="display: inline-block;width: 350px">
        <dg-text-field
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark=""
            @amUpdated="filterValueUpdated"
            label="Filter Value"
            name="filterValue"
            placeholder="Early Media / Answered ..."
            rules="optional"></dg-text-field>
      </div>-->
      <div class="col-12 col-md-6">
        <span style="display: inline-block;margin-right: 20px;">
          <el-button type="primary" size="mini" icon="el-icon-search" @click="buildListRequest(1)">Search</el-button>
        </span>
        <span style="display: inline-block;margin-right: 20px;">
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeAllSipDialerHistoryAction">Remove All</el-button>
        </span>
        <span style="display: inline-block;margin-right: 20px;">
              <el-tag type="success">Records: {{ recordsCounter }}</el-tag> <small>20 record per page</small>
        </span>
        <pagination
            :currentPage.sync="currentPage"
            :margin-pages="2"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            :page-range="4"
            paginateClass=""></pagination>
      </div>
    </div>

    <el-dialog :append-to-body="true" :visible.sync="dialogVisible"
               class="call-test-results-dialog" title="" top="5vh" width="98%">
      <callTestResultsTable :callTestRequest="callTestRequest" :broadcastPublicId="broadcastPublicId" :liveDataResults='liveDataResults'
                            :numberOfCalls="number_of_calls" :testFinalStatus="testFinalStatus"
                            v-if="dialogVisible">
      </callTestResultsTable>
    </el-dialog>

    <el-dialog :visible.sync="deleteDialogVisible" center title="Warning" width="420px" :append-to-body="true">
      <div align="center" class="mt-2 mb-2">Are you sure you want to remove all records ?</div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="deleteDialogVisible = false" size="small">Cancel</el-button>
        <el-button @click="removeActionApi" size="small" type="danger">Yes</el-button>
      </span>
    </el-dialog>


    <div v-for="(broadcast, key) in broadcastCdrs" :key="key" class="mb-3 border">
      <callTestResultsTable :callTestRequest="broadcast.callTestRequest" :broadcastPublicId="broadcast.broadcastPublicId" :liveDataResults='broadcast.liveDataResults'
        :numberOfCalls="broadcast.number_of_calls" :testFinalStatus="broadcast.testFinalStatus">
      </callTestResultsTable>
    </div>

    <!--<el-table v-if="amReady" :data="tableData" border cell-class-name="p-1" stripe style="width: 100%">
      <el-table-column type="expand">
      </el-table-column>
      <el-table-column
          label="Prefix"
          prop="prefix"
          width="150">
      </el-table-column>
      <el-table-column
          label="Destination"
          prop="destination">
      </el-table-column>
      <el-table-column
          label="Code"
          prop="dialcode">
      </el-table-column>
      <el-table-column
          label="Rate"
          prop="rate">
      </el-table-column>
      <el-table-column
          label="Time"
          prop="execution_time">
      </el-table-column>
      <el-table-column
          label="Type"
          prop="call_destination_name">
      </el-table-column>
      <el-table-column
          label="caller"
          prop="caller_id">
      </el-table-column>
      <el-table-column
          align="right"
          label="Actions"
          prop="">
        <template slot-scope="scope">
          <el-button icon="el-icon-view" @click="showLiveResults(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>-->
  </div>

</template>

<script>
import {notify} from "@/system-services/notify";

export default {
  components: {
    callTestResultsTable: () => import('@/components/call-test-results-table/View')
  },
  props: {
    fusionServerId: {
      required: true
    },
    sipDialerId: {
      required: true
    }
  },
  data() {
    return {
      selectedFilterOption: '',
      selectedFilterValue: '',
      filterOptions: [
        {label: 'None', value: ''},
        {label: 'EndPoint - Early Media', value: 'endpoint_disposition=EARLY'},
        {label: 'EndPoint - Answer', value: 'endpoint_disposition=ANSWER'}
      ],
      amReady: false,
      broadcastCdrs: [],
      dialogVisible: false,
      userSearchTimeOut: null,
      recordsCounter: 0,
      pageChunkSize: 20,
      currentPage: 1,
      tableData: [],
      callTestRequest: null,
      broadcastPublicId: null,
      liveDataResults: null,
      number_of_calls: null,
      testFinalStatus: null,
      deleteDialogVisible: false
    }
  },
  beforeMount() {
    this.buildListRequest(this.currentPage)
  },
  methods: {
    filterOptionsUpdated(inputField) {
      this.selectedFilterOption = inputField.field.field_value
      if (this.selectedFilterOption != '') {
        this.broadcastCdrs = 0
        $vue.nextTick(() => {
          this.broadcastCdrs = []
          this.buildListRequest(1);
        })
      }
    },
    filterValueUpdated(inputField) {
      this.selectedFilterValue = inputField.field.field_value
    },
    ...$mapActions('voip-sip-dialer-api', {getSipDialerHistory: 'getSipDialerHistory'}),
    ...$mapActions('voip-testing-panel-api', {getBroadcastCdr: 'getBroadcastCdr'}),
    removeAllSipDialerHistoryAction(params) {
      this.deleteDialogVisible = true
    },
    removeActionApi() {
      this.deleteDialogVisible = false
      this.$store.dispatch('voip-sip-dialer-api/removeAllSipDialerHistory', {sipDialerId: this.sipDialerId}).then(response => {
        this.tableData = []
        this.recordsCounter = 0;
        notify({
          type: 'success',
          title: 'Success',
        });
      })
    },
    showLiveResults(rowData) {
      this.dialogVisible = true
      this.liveDataResults = []
      this.getBroadcastCdr({id: rowData.id}).then(response => {
        let cdr = response.data

        this.broadcastPublicId = rowData.public_id
        this.callTestRequest = cdr
        this.liveDataResults = JSON.parse(cdr.cdr_json)
        this.number_of_calls = cdr.number_of_calls
        this.testFinalStatus = cdr.system_call_test_status_id
      })
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    getBroadCastsCdrs () {
      let count =
          this.tableData.length
      this.broadcastCdrs = []
      $vue.nextTick( () => {
        for (let i = 0; i < count; i++) {
          let t = this.tableData[i]
          this.getBroadcastCdr({id: t.id}).then(response => {
            let cdr = response.data
            this.broadcastCdrs.push({
              broadcastPublicId: t.public_id,
              callTestRequest: cdr,
              liveDataResults: JSON.parse(cdr.cdr_json),
              number_of_calls: cdr.number_of_calls,
              testFinalStatus: cdr.system_call_test_status_id,
            })

          })
        }
      })
    },
    navigateToPage(page) {this.buildListRequest(page)},
    getPagesCount() {return Math.ceil(this.recordsCounter / this.pageChunkSize)},
    buildListRequest(page) {
      this.getSipDialerHistory({filterOption: this.selectedFilterOption, fusionServerId: this.fusionServerId, sipDialerId: this.sipDialerId, page: page, search: this.userSearch}).then(r => {
        this.rowData = null
        $vue.nextTick(() => {
          this.tableData = r.rows
          this.recordsCounter = r.count
          this.getBroadCastsCdrs()
          this.amReady = true
        })
      })
      this.currentPage = page
    },
  }
}
</script>
